var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.89375 1.25C11.35 1.25 14.15 4.0625 14.15 7.5C14.15 10.9375 11.35 13.75 7.89375 13.75C5.7 13.75 3.78125 12.6125 2.6625 10.8938L3.65 10.1125C4.53125 11.5437 6.1 12.5 7.9 12.5C9.22608 12.5 10.4979 11.9732 11.4355 11.0355C12.3732 10.0979 12.9 8.82608 12.9 7.5C12.9 6.17392 12.3732 4.90215 11.4355 3.96447C10.4979 3.02678 9.22608 2.5 7.9 2.5C5.35 2.5 3.25 4.4125 2.94375 6.875H4.66875L2.33125 9.20625L0 6.875H1.68125C1.99375 3.71875 4.65625 1.25 7.89375 1.25ZM9.74375 6.4C10.0562 6.40625 10.3125 6.65625 10.3125 6.975V9.85625C10.3125 10.1688 10.0562 10.4313 9.7375 10.4313H6.28125C5.9625 10.4313 5.70625 10.1688 5.70625 9.85625V6.975C5.70625 6.65625 5.9625 6.40625 6.275 6.4V5.76875C6.275 4.8125 7.05625 4.0375 8.00625 4.0375C8.9625 4.0375 9.74375 4.8125 9.74375 5.76875V6.4ZM8.00625 4.9125C7.5375 4.9125 7.15 5.29375 7.15 5.76875V6.4H8.86875V5.76875C8.86875 5.29375 8.48125 4.9125 8.00625 4.9125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordReset);
export default __webpack_public_path__ + "static/media/password-reset.a016e5564b7b32d80edbb0926c487f32.svg";
export { ForwardRef as ReactComponent };